import { defineMutatorWithType, defineMutators, defineQueries, defineQueryWithType, } from "@rocicorp/zero";
import { createAdminDataMutators, createAdminDataQueries, } from "./project-domains/admin-data.js";
import { createCollaborationMutators, createCollaborationQueries, } from "./project-domains/collaboration.js";
import { createCoreMutators, createCoreQueries, } from "./project-domains/core.js";
import { createDocumentMutators, createDocumentQueries, } from "./project-domains/documents.js";
import { createFinanceMutators, createFinanceQueries, } from "./project-domains/finance.js";
import { createHrMutators, createHrQueries } from "./project-domains/hr.js";
import { createIntercomMutators, createIntercomQueries, } from "./project-domains/intercom.js";
import { createPeoplePlanningMutators, createPeoplePlanningQueries, } from "./project-domains/people-planning.js";
import { createStreamingMutators, createStreamingQueries, } from "./project-domains/streaming.js";
import { assertAdminDataWriteAccess, replacePersonAllergyTags, } from "./projects-helpers.js";
import { projectZql, } from "./projects-schema.js";
import { createPublicHolidayInputSchema, updatePublicHolidayInputSchema, publicHolidayIDInputSchema, createEmployeeAbsenceInputSchema, updateEmployeeAbsenceInputSchema, employeeAbsenceIDInputSchema, upsertEmployeeEntitlementInputSchema, createEmploymentPeriodInputSchema, updateEmploymentPeriodInputSchema, employmentPeriodIDInputSchema, createOvertimePayoutInputSchema, overtimePayoutIDInputSchema, updateAppSettingInputSchema, createAllergyTagInputSchema, setPersonAllergyTagsInputSchema, createStudioInputSchema, updateStudioInputSchema, studioIDInputSchema, createStudioConfigInputSchema, updateStudioConfigInputSchema, deleteStudioConfigInputSchema, restoreStudioConfigVersionInputSchema, createStudioConnectionInputSchema, updateStudioConnectionInputSchema, deleteStudioConnectionInputSchema, createBrokerInputSchema, updateBrokerInputSchema, deleteBrokerInputSchema, createBrokerOutputInputSchema, updateBrokerOutputInputSchema, deleteBrokerOutputInputSchema, createProfileInputSchema, updateProfileInputSchema, profileIDInputSchema, createStreamInputSchema, updateStreamInputSchema, deleteStreamInputSchema, createStreamAudioPairInputSchema, deleteStreamAudioPairInputSchema, createStreamOutputInputSchema, updateStreamOutputInputSchema, deleteStreamOutputInputSchema, createStreamBrokerInputSchema, updateStreamBrokerInputSchema, deleteStreamBrokerInputSchema, createProjectAwsResourceLinkInputSchema, updateProjectAwsResourceLinkInputSchema, deleteProjectAwsResourceLinkInputSchema, createStreamAudioFeedInputSchema, deleteStreamAudioFeedInputSchema, updateStreamAudioFeedInputSchema, createStreamVideoFeedInputSchema, deleteStreamVideoFeedInputSchema, updateStreamVideoFeedInputSchema, createStreamSignalInputSchema, deleteStreamSignalInputSchema, updateStreamSignalInputSchema, createStreamSignalAudioFeedInputSchema, updateStreamSignalAudioFeedInputSchema, deleteStreamSignalAudioFeedInputSchema, createStreamTakerInputSchema, updateStreamTakerInputSchema, deleteStreamTakerInputSchema, createStreamTakerAudioPairInputSchema, updateStreamTakerAudioPairInputSchema, deleteStreamTakerAudioPairInputSchema, createStreamTakerContactInputSchema, updateStreamTakerContactInputSchema, deleteStreamTakerContactInputSchema, createStreamTakerAudioPairTestInputSchema, updateStreamTakerAudioPairTestInputSchema, deleteStreamTakerAudioPairTestInputSchema, createDefaultFunctionInputSchema, updateDefaultFunctionInputSchema, defaultFunctionIDInputSchema, upsertSkillRatingInputSchema, deleteSkillRatingInputSchema, upsertProjectAvailabilityInputSchema, batchUpsertProjectAvailabilityInputSchema, deleteProjectAvailabilityInputSchema, updateProjectAvailabilityRemarkInputSchema, updateProjectAvailabilityUnityUsernameInputSchema, createProjectContactInputSchema, updateProjectContactInputSchema, deleteProjectContactInputSchema, upsertProjectMealPlanInputSchema, batchUpsertProjectMealPlansInputSchema, upsertProjectHotelPlanInputSchema, batchUpsertProjectHotelPlansInputSchema, linkNetworkCoverageSessionInputSchema, unlinkNetworkCoverageSessionInputSchema, createProjectFunctionSeriesInputSchema, updateProjectFunctionSeriesInputSchema, deleteProjectFunctionSeriesInputSchema, updateProjectFunctionDayInputSchema, createFunctionAssignmentInputSchema, bulkAssignFunctionSeriesInputSchema, updateFunctionAssignmentInputSchema, deleteFunctionAssignmentInputSchema, initializeProjectFunctionsInputSchema, createTaskInputSchema, updateTaskInputSchema, taskIDInputSchema, taskAssigneeInputSchema, taskProjectInputSchema, taskProjectGroupInputSchema, markNotificationReadInputSchema, markAllNotificationsReadInputSchema, createCommentInputSchema, commentIDInputSchema, createStudioDocumentInputSchema, updateStudioDocumentInputSchema, studioDocumentIDInputSchema, createGlobalDocumentInputSchema, updateGlobalDocumentInputSchema, globalDocumentIDInputSchema, createGlobalDocumentLinkInputSchema, deleteGlobalDocumentLinkInputSchema, createMeetingNoteInputSchema, updateMeetingNoteInputSchema, meetingNoteIDInputSchema, createMeetingNoteTagInputSchema, updateMeetingNoteTagInputSchema, meetingNoteTagIDInputSchema, createQuoteLineItemTemplateInputSchema, updateQuoteLineItemTemplateInputSchema, quoteLineItemTemplateIDInputSchema, renameQuoteLineItemTemplateCategoryInputSchema, createQuoteGroupTemplateInputSchema, updateQuoteGroupTemplateInputSchema, quoteGroupTemplateIDInputSchema, renameQuoteGroupTemplateCategoryInputSchema, createQuoteInputSchema, updateQuoteInputSchema, quoteIDInputSchema, createQuoteVersionInputSchema, updateQuoteVersionInputSchema, quoteVersionIDInputSchema, setQuoteVersionStatusInputSchema, createQuoteGroupInputSchema, updateQuoteGroupInputSchema, quoteGroupIDInputSchema, createQuoteLineItemInputSchema, updateQuoteLineItemInputSchema, quoteLineItemIDInputSchema, reorderQuoteLineItemsInputSchema, duplicateQuoteGroupInputSchema, duplicateQuoteVersionContentInputSchema, createQuoteDeductionItemInputSchema, updateQuoteDeductionItemInputSchema, quoteDeductionItemIDInputSchema, createInvoiceInputSchema, updateInvoiceInputSchema, invoiceIDInputSchema, transitionInvoiceStatusInputSchema, createInvoiceReminderInputSchema, updateInvoiceReminderInputSchema, invoiceReminderIDInputSchema, createInvoiceGroupInputSchema, updateInvoiceGroupInputSchema, invoiceGroupIDInputSchema, createInvoiceLineItemInputSchema, updateInvoiceLineItemInputSchema, invoiceLineItemIDInputSchema, reorderInvoiceLineItemsInputSchema, duplicateInvoiceGroupInputSchema, createInvoiceDeductionItemInputSchema, updateInvoiceDeductionItemInputSchema, invoiceDeductionItemIDInputSchema, copyQuoteContentToInvoiceInputSchema, createIntercomChannelInputSchema, updateIntercomChannelInputSchema, intercomChannelIDInputSchema, createIntercomAssignmentInputSchema, updateIntercomAssignmentInputSchema, intercomAssignmentIDInputSchema, createIntercomProfileInputSchema, updateIntercomProfileInputSchema, intercomProfileIDInputSchema, bulkAssignIntercomProfileInputSchema, } from "./projects-input-schemas.js";
export * from "./projects-input-schemas.js";
export { projectRelationshipsList, projectSchema, projectTables, projectZql, } from "./projects-schema.js";
const defineProjectQuery = defineQueryWithType();
const defineProjectMutator = defineMutatorWithType();
const coreQueries = createCoreQueries({
    defineProjectQuery,
    projectZql,
});
const adminDataQueries = createAdminDataQueries({
    defineProjectQuery,
    projectZql,
});
const financeQueries = createFinanceQueries({
    defineProjectQuery,
    projectZql,
});
const documentQueries = createDocumentQueries({
    defineProjectQuery,
    projectZql,
});
const streamingQueries = createStreamingQueries({
    defineProjectQuery,
    projectZql,
});
const hrQueries = createHrQueries({
    defineProjectQuery,
    projectZql,
});
const peoplePlanningQueries = createPeoplePlanningQueries({
    defineProjectQuery,
    projectZql,
});
const intercomQueries = createIntercomQueries({
    defineProjectQuery,
    projectZql,
});
const collaborationQueries = createCollaborationQueries({
    defineProjectQuery,
    projectZql,
});
function authorizedClockifyTimeEntriesQuery(ctx) {
    if (ctx.role === "admin" || ctx.role === "employee") {
        return projectZql.clockifyTimeEntries;
    }
    return projectZql.clockifyTimeEntries.where("id", "__unauthorized__");
}
export const projectQueryDefinitions = {
    ...coreQueries,
    ...hrQueries,
    ...adminDataQueries,
    ...documentQueries,
    ...streamingQueries,
    ...peoplePlanningQueries,
    ...intercomQueries,
    ...collaborationQueries,
    ...financeQueries,
    clockifyTimeEntries: {
        byProject: defineProjectQuery(({ args, ctx }) => authorizedClockifyTimeEntriesQuery(ctx)
            .where("projectID", args.projectID)
            .related("people")
            .orderBy("startTime", "desc")),
        byProjectGroup: defineProjectQuery(({ args, ctx, }) => authorizedClockifyTimeEntriesQuery(ctx)
            .where("projectGroupID", args.projectGroupID)
            .related("people")
            .orderBy("startTime", "desc")),
    },
};
export const projectQueries = defineQueries(projectQueryDefinitions);
const coreMutators = createCoreMutators({
    defineProjectMutator,
    projectZql,
});
const adminDataMutators = createAdminDataMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        updateAppSettingInputSchema,
        createAllergyTagInputSchema,
        setPersonAllergyTagsInputSchema,
    },
    assertAdminDataWriteAccess,
    replacePersonAllergyTags,
});
const documentMutators = createDocumentMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createStudioDocumentInputSchema,
        updateStudioDocumentInputSchema,
        studioDocumentIDInputSchema,
        createGlobalDocumentInputSchema,
        updateGlobalDocumentInputSchema,
        globalDocumentIDInputSchema,
        createGlobalDocumentLinkInputSchema,
        deleteGlobalDocumentLinkInputSchema,
    },
    assertAdminDataWriteAccess,
});
const financeMutators = createFinanceMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createQuoteLineItemTemplateInputSchema,
        updateQuoteLineItemTemplateInputSchema,
        quoteLineItemTemplateIDInputSchema,
        renameQuoteLineItemTemplateCategoryInputSchema,
        createQuoteGroupTemplateInputSchema,
        updateQuoteGroupTemplateInputSchema,
        quoteGroupTemplateIDInputSchema,
        renameQuoteGroupTemplateCategoryInputSchema,
        createQuoteInputSchema,
        updateQuoteInputSchema,
        quoteIDInputSchema,
        createQuoteVersionInputSchema,
        updateQuoteVersionInputSchema,
        quoteVersionIDInputSchema,
        setQuoteVersionStatusInputSchema,
        createInvoiceInputSchema,
        updateInvoiceInputSchema,
        invoiceIDInputSchema,
        transitionInvoiceStatusInputSchema,
        createInvoiceReminderInputSchema,
        updateInvoiceReminderInputSchema,
        invoiceReminderIDInputSchema,
        createInvoiceGroupInputSchema,
        updateInvoiceGroupInputSchema,
        invoiceGroupIDInputSchema,
        duplicateInvoiceGroupInputSchema,
        copyQuoteContentToInvoiceInputSchema,
        createInvoiceLineItemInputSchema,
        updateInvoiceLineItemInputSchema,
        invoiceLineItemIDInputSchema,
        reorderInvoiceLineItemsInputSchema,
        createInvoiceDeductionItemInputSchema,
        updateInvoiceDeductionItemInputSchema,
        invoiceDeductionItemIDInputSchema,
        createQuoteGroupInputSchema,
        updateQuoteGroupInputSchema,
        quoteGroupIDInputSchema,
        duplicateQuoteGroupInputSchema,
        duplicateQuoteVersionContentInputSchema,
        createQuoteLineItemInputSchema,
        updateQuoteLineItemInputSchema,
        quoteLineItemIDInputSchema,
        reorderQuoteLineItemsInputSchema,
        createQuoteDeductionItemInputSchema,
        updateQuoteDeductionItemInputSchema,
        quoteDeductionItemIDInputSchema,
    },
});
const streamingMutators = createStreamingMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createStudioInputSchema,
        updateStudioInputSchema,
        studioIDInputSchema,
        createStudioConfigInputSchema,
        updateStudioConfigInputSchema,
        deleteStudioConfigInputSchema,
        restoreStudioConfigVersionInputSchema,
        createStudioConnectionInputSchema,
        updateStudioConnectionInputSchema,
        deleteStudioConnectionInputSchema,
        createBrokerInputSchema,
        updateBrokerInputSchema,
        deleteBrokerInputSchema,
        createBrokerOutputInputSchema,
        updateBrokerOutputInputSchema,
        deleteBrokerOutputInputSchema,
        createProfileInputSchema,
        updateProfileInputSchema,
        profileIDInputSchema,
        createStreamInputSchema,
        updateStreamInputSchema,
        deleteStreamInputSchema,
        createStreamAudioPairInputSchema,
        deleteStreamAudioPairInputSchema,
        createStreamOutputInputSchema,
        updateStreamOutputInputSchema,
        deleteStreamOutputInputSchema,
        createStreamBrokerInputSchema,
        updateStreamBrokerInputSchema,
        deleteStreamBrokerInputSchema,
        createProjectAwsResourceLinkInputSchema,
        updateProjectAwsResourceLinkInputSchema,
        deleteProjectAwsResourceLinkInputSchema,
        createStreamAudioFeedInputSchema,
        deleteStreamAudioFeedInputSchema,
        updateStreamAudioFeedInputSchema,
        createStreamVideoFeedInputSchema,
        deleteStreamVideoFeedInputSchema,
        updateStreamVideoFeedInputSchema,
        createStreamSignalInputSchema,
        deleteStreamSignalInputSchema,
        updateStreamSignalInputSchema,
        createStreamSignalAudioFeedInputSchema,
        updateStreamSignalAudioFeedInputSchema,
        deleteStreamSignalAudioFeedInputSchema,
        createStreamTakerInputSchema,
        updateStreamTakerInputSchema,
        deleteStreamTakerInputSchema,
        createStreamTakerAudioPairInputSchema,
        updateStreamTakerAudioPairInputSchema,
        deleteStreamTakerAudioPairInputSchema,
        createStreamTakerContactInputSchema,
        updateStreamTakerContactInputSchema,
        deleteStreamTakerContactInputSchema,
        createStreamTakerAudioPairTestInputSchema,
        updateStreamTakerAudioPairTestInputSchema,
        deleteStreamTakerAudioPairTestInputSchema,
    },
});
const hrMutators = createHrMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createPublicHolidayInputSchema,
        updatePublicHolidayInputSchema,
        publicHolidayIDInputSchema,
        createEmployeeAbsenceInputSchema,
        updateEmployeeAbsenceInputSchema,
        employeeAbsenceIDInputSchema,
        upsertEmployeeEntitlementInputSchema,
        createEmploymentPeriodInputSchema,
        updateEmploymentPeriodInputSchema,
        employmentPeriodIDInputSchema,
        createOvertimePayoutInputSchema,
        overtimePayoutIDInputSchema,
    },
});
const peoplePlanningMutators = createPeoplePlanningMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createDefaultFunctionInputSchema,
        updateDefaultFunctionInputSchema,
        defaultFunctionIDInputSchema,
        upsertSkillRatingInputSchema,
        deleteSkillRatingInputSchema,
        upsertProjectAvailabilityInputSchema,
        batchUpsertProjectAvailabilityInputSchema,
        deleteProjectAvailabilityInputSchema,
        updateProjectAvailabilityRemarkInputSchema,
        updateProjectAvailabilityUnityUsernameInputSchema,
        createProjectContactInputSchema,
        updateProjectContactInputSchema,
        deleteProjectContactInputSchema,
        upsertProjectMealPlanInputSchema,
        batchUpsertProjectMealPlansInputSchema,
        upsertProjectHotelPlanInputSchema,
        batchUpsertProjectHotelPlansInputSchema,
        linkNetworkCoverageSessionInputSchema,
        unlinkNetworkCoverageSessionInputSchema,
        createProjectFunctionSeriesInputSchema,
        updateProjectFunctionSeriesInputSchema,
        deleteProjectFunctionSeriesInputSchema,
        updateProjectFunctionDayInputSchema,
        createFunctionAssignmentInputSchema,
        bulkAssignFunctionSeriesInputSchema,
        updateFunctionAssignmentInputSchema,
        deleteFunctionAssignmentInputSchema,
        initializeProjectFunctionsInputSchema,
    },
});
const intercomMutators = createIntercomMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createIntercomChannelInputSchema,
        updateIntercomChannelInputSchema,
        intercomChannelIDInputSchema,
        createIntercomAssignmentInputSchema,
        updateIntercomAssignmentInputSchema,
        intercomAssignmentIDInputSchema,
        createIntercomProfileInputSchema,
        updateIntercomProfileInputSchema,
        intercomProfileIDInputSchema,
        bulkAssignIntercomProfileInputSchema,
    },
});
const collaborationMutators = createCollaborationMutators({
    defineProjectMutator,
    projectZql,
    schemas: {
        createTaskInputSchema,
        updateTaskInputSchema,
        taskIDInputSchema,
        taskAssigneeInputSchema,
        taskProjectInputSchema,
        taskProjectGroupInputSchema,
        markNotificationReadInputSchema,
        markAllNotificationsReadInputSchema,
        createCommentInputSchema,
        commentIDInputSchema,
        createMeetingNoteInputSchema,
        updateMeetingNoteInputSchema,
        meetingNoteIDInputSchema,
        createMeetingNoteTagInputSchema,
        updateMeetingNoteTagInputSchema,
        meetingNoteTagIDInputSchema,
    },
});
export const projectMutatorDefinitions = {
    ...coreMutators,
    ...hrMutators,
    ...adminDataMutators,
    ...documentMutators,
    ...streamingMutators,
    ...peoplePlanningMutators,
    ...intercomMutators,
    ...collaborationMutators,
    ...financeMutators,
};
export const projectMutators = defineMutators(projectMutatorDefinitions);
